import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { ref, onMounted } from 'vue';
import { MoonIcon, SunIcon } from '@heroicons/vue/24/solid';
import { useI18n } from 'vue-i18n';

import UiButton from '@/components/ui/UiButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiThemeToggle',
  setup(__props) {

const { t } = useI18n();

// Data
const theme = ref<'light' | 'dark'>('light');

// Methods
const applyTheme = (value: 'light' | 'dark') => {
  theme.value = value;
  localStorage.setItem('theme', value);
  const html = document.documentElement;

  if (value === 'dark') {
    html.classList.add('dark');
  } else {
    html.classList.remove('dark');
  }
};

const toggleTheme = () => {
  applyTheme(theme.value === 'dark' ? 'light' : 'dark');
};

// Lifecycle
onMounted(() => {
  const saved = localStorage.getItem('theme') as 'light' | 'dark' | null;
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  applyTheme(saved || (prefersDark ? 'dark' : 'light'));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiButton, {
    variant: "ghost",
    color: "gray",
    "aria-label": theme.value === 'dark' ? 'Switch to light mode' : 'Switch to dark mode',
    onClick: toggleTheme
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(theme.value === 'dark' ? _unref(MoonIcon) : _unref(SunIcon)), { class: "h-6 w-6 text-gray-800 dark:text-gray-100 transition-transform" }))
    ]),
    _: 1
  }, 8, ["aria-label"]))
}
}

})